import { css, FunctionInterpolation } from '@emotion/react';
import { PropsWithTheme } from '@lbcamden/lib-react';

export const animateCollapsibleContent: FunctionInterpolation<PropsWithTheme> = ({ theme }) => css`
  overflow: hidden;
  will-change: height;

  &[data-state='open'] {
    animation: ${theme.transitions.create('slide-down')};
  }

  &[data-state='closed'] {
    animation: ${theme.transitions.create('slide-up')};
  }

  @keyframes slide-down {
    from {
      height: 0;
    }

    to {
      height: var(--radix-collapsible-content-height);
    }
  }

  @keyframes slide-up {
    from {
      height: var(--radix-collapsible-content-height);
    }

    to {
      height: 0;
    }
  }
`;
